import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Best-effort, fire-and-forget page/navigation logging for the coach's
// Activity Log view. Never blocks or throws - it must not affect the UX
// of the page calling it.
export const logActivity = (eventType) => {
  axios.post(`${API}/activity/log`, { event_type: eventType }).catch(() => {});
};
